import { MutationCache, QueryClient } from '@tanstack/react-query'
import { readProperty } from '@/lib/utils'

export function isAuditLogQuery(query: { queryKey: readonly unknown[] }): boolean
export function isAuditLogQuery(query?: { queryKey?: readonly unknown[] }): boolean | undefined
export function isAuditLogQuery({ queryKey }: { queryKey?: readonly unknown[] } = {}):
  | boolean
  | undefined {
  return queryKey?.some(
    (keyPart) => typeof keyPart === 'object' && readProperty(keyPart, 'entity') === 'audit-log'
  )
}

export function createAdminQueryClient(): QueryClient {
  const mutationCache = new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: isAuditLogQuery,
      })
    },
  })

  const queryClient = new QueryClient({
    mutationCache,
    defaultOptions: {
      queries: {
        staleTime: 20_000,
        retry: (failureCount, error: unknown) => {
          const status = readProperty(readProperty(error, 'response'), 'status')
          if (typeof status === 'number' && [401, 403, 404, 419, 429].includes(status)) {
            return false
          }
          return failureCount < 2
        },
      },
    },
  })

  return queryClient
}

const queryClient = createAdminQueryClient()

export default queryClient
